// extracted by mini-css-extract-plugin
export default {"topskillsMain":"style_topskillsMain__EjJ-3","fs_h3":"style_fs_h3__v4xxc"};